import { ErrorMessage } from '@hookform/error-message';

import { Card, FormItem, ListLayout, MultiSelect, OptionList, TextInput } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { useSiteTagListQuery } from '../queries';
import { useTemplateFormContext } from '../types';

export function BasicInformation() {
  const { data: tags = [], isLoading: isLoadingTags } = useSiteTagListQuery();
  const { register, setValue, watch, formState } = useTemplateFormContext();
  const { t } = useTranslation();

  return (
    <Card.List>
      <Card.Wrapper as="section">
        <Card.Header>{t('common.basicInformation')}</Card.Header>
        <Card.Content>
          <ListLayout.Column>
            <FormItem.Root>
              <FormItem.Label>{t('shipmentTemplates.details.templateName')}</FormItem.Label>
              <FormItem.Control invalid={!!formState.errors.name}>
                <TextInput aria-required="true" {...register('name', { required: true })} />
              </FormItem.Control>

              <ErrorMessage as={FormItem.ErrorText} errors={formState.errors} name="name" />
            </FormItem.Root>

            <FormItem.Root>
              <FormItem.Label>{t('common.tags')}</FormItem.Label>
              <FormItem.Control>
                <MultiSelect.Root
                  onValueChange={ids => {
                    setValue(
                      'tags',
                      ids.map(v => ({ id: v }))
                    );
                  }}
                  value={watch('tags')?.map(tag => tag.id!)}
                  disabled={isLoadingTags}
                >
                  <MultiSelect.Trigger
                    options={tags.map(({ id, name }) => [id!, name!])}
                    placeholder={t('shipments.create.selectTags')}
                  />

                  <MultiSelect.Content>
                    <OptionList.Viewport>
                      {tags.map(({ id, name }) => (
                        <OptionList.Item key={id} text={name} value={id!}>
                          <OptionList.ItemText>{name}</OptionList.ItemText>
                          <OptionList.ItemIndicator />
                        </OptionList.Item>
                      ))}
                    </OptionList.Viewport>
                  </MultiSelect.Content>
                </MultiSelect.Root>
              </FormItem.Control>
            </FormItem.Root>
          </ListLayout.Column>
        </Card.Content>
      </Card.Wrapper>
    </Card.List>
  );
}
